webpackJsonp([114302956264202],{

/***/ 1355:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"10 Tips to Nail Your Next Networking Event","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/10-tips-to-nail-your-next-networking-event","createdAt":"2017-07-18T17:20:34.834Z","blogAuthor":{"fields":{"name":"Izzy Baer","slug":"blog/author/izzy-baer"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4SHf4tcENGIIKMqm06souq/54fb7da3456cdca9d3b52682bfd37b80/blog-post-blog-10-tips-to-nail-your-next-networking-event.png"}}}}}]},"authorJson":{"name":"Izzy Baer","slug":"blog/author/izzy-baer","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/izzy-baer"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-izzy-baer-1b783196d6dd1c2731d7.js